import { resize } from './js/functions.js';
import { player } from './js/libs/howler/player.js';

////////////////////////////////////////////////////////
window.addEventListener("DOMContentLoaded", function() {
  
  console.log("index.js was run");

});